import { RequestType } from '@approvalmax/data';

/**
 * We have issues with schema typings for this endpoint now
 * Have to provide types manually
 * TODO: replace with correct backend type
 */
export type GetPaymentDetailsRequirements = RequestType<
    {
        params: {
            path: {
                companyId: string;
            };
            query: {
                currencyCode: string;
                payerBankCountry: string;
                payeeBankCountry: string;
            };
        };
        response: PaymentDetailsRequirementsItem[];
    },
    {
        apiSource: 'webApp';
        apiMethod: 'get';
        apiVersion: 'v2';
    }
>;

export interface FieldWithRequirement {
    requirement: string;
    description: string | null;
}

export enum PaymentDetailsPaymentType {
    Regular = 1,
    Priority = 2,
}

export enum PaymentDetailsLegalEntityType {
    Individual = 1,
    Company = 2,
}

export interface PaymentDetailsRequirementsItem {
    paymentTypeField: {
        paymentType: PaymentDetailsPaymentType;
        description: string | null;
    };
    legalEntityTypeField: {
        legalEntityType: PaymentDetailsLegalEntityType;
        description: string | null;
    };
    legalEntityCountryField: FieldWithRequirement | null;
    legalEntityAddressLineField: FieldWithRequirement | null;
    legalEntityCityField: FieldWithRequirement | null;
    legalEntityPostCodeField: FieldWithRequirement | null;
    legalEntityStateOrProvinceField: FieldWithRequirement | null;
    legalEntityPersonFirstNameField: FieldWithRequirement | null;
    legalEntityPersonLastNameField: FieldWithRequirement | null;
    legalEntityCompanyNameField: FieldWithRequirement | null;
    sortCodeField: FieldWithRequirement | null;
    accountNumberField: FieldWithRequirement | null;
    ibanField: FieldWithRequirement | null;
    bicSwiftField: FieldWithRequirement | null;
    abaField: FieldWithRequirement | null;
    bsbField: FieldWithRequirement | null;
    clabeField: FieldWithRequirement | null;
    cnapsField: FieldWithRequirement | null;
    ifscField: FieldWithRequirement | null;
    institutionNumberField: FieldWithRequirement | null;
    bankCodeField: FieldWithRequirement | null;
    branchCodeField: FieldWithRequirement | null;
    incorporationNumberField: FieldWithRequirement | null;
    payNetworkName: string;
}
